export function normalizeApiError(error, fallback) {
  const data = error?.response?.data ?? error;

  if(data === "") {
    return fallback
  }

  if (data?.error?.message) {
    return data.error.message
  }

  if (data?.errors && typeof data.errors === "object") {
    const fieldMessages = Object.values(data.errors)
      .flat()
      .join(" ");

      return fieldMessages
  }

  if(typeof data === "string") {
    return data
  }

  return fallback
}
